import React, { Component } from "react"

import { connect } from "react-redux"
import { translate } from "react-translate"
import { Link } from "react-router-dom"

import { Segment, Dropdown, Menu } from "semantic-ui-react"
import MenuEdition from "./MenuEdition"
import BandeauNoir from "../../Entete/BandeauNoir"
import BouttonEntete from "../../Entete/BouttonEntete"
import { fileText2 } from "react-icons-kit/icomoon/fileText2"
import { ic_border_color } from "react-icons-kit/md/ic_border_color"
import { download } from "react-icons-kit/typicons/download"
import Devis from "./Devis"
import ButtonModif from "./ButtonModif"
import "./EditionDevisFacturesComponent.css"
import "./MenuEdition.css"
import _ from "lodash"

const options = [
  { key: "Action", text: "value_dropdown_action", value: "Action" },
  { key: "org", text: "value_dropdown_create", value: "org" },
  { key: "site", text: "value_dropdown_delete", value: "site" }
]

const mapStateToProps = state => ({
  app: state.app
})

class ConnectedEditDevisFacturesComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      dateDevisFacturesData: [{ dateEnteteBody: "Janvier 2017 :" }]
    }
  }

  componentWillMount() {
    let { t } = this.props
    var optionsCopy = _.clone(options)
    optionsCopy = _.map(optionsCopy, x => {
      return {
        ...x,
        text: t(x.text)
      }
    })

    this.setState({
      options: optionsCopy
    })
  }

  render() {
    let { t } = this.props
    return (
      <Segment id="main">
        <BandeauNoir icon={fileText2} category={t("title_bandeau_component")}>
          <BouttonEntete
            text={t("title_bandeau_button_component")}
            style="bouttonEnteteDevis0"
            icon={ic_border_color}
          />
          <Dropdown
            button
            floating
            options={this.state.options || []}
            defaultValue="Action"
            id="bouttonEnteteDevis3"
          />

          <BouttonEntete
            text={t("label_bandeau_button_download")}
            style="bouttonEnteteDevis2"
            icon={download}
          />
          <ButtonModif />
          <hr id="hrEdition" />
          <Segment inverted id="menuEdition">
            <Menu inverted pointing secondary id="divEdition">
              <MenuEdition
                name={t("menu_label_bandeau_apercu")}
                nameIcon="braille"
                id="itemEdition"
              />
              <MenuEdition
                name={t("menu_label_bandeau_note")}
                nameIcon="clipboard"
                id="itemEdition"
              />
              <MenuEdition
                name={t("menu_label_bandeau_historique")}
                nameIcon="clock"
                id="itemEdition"
              />
            </Menu>
          </Segment>
        </BandeauNoir>
        <Devis />
      </Segment>
    )
  }
}

const EditionDevisFacturesComponent = connect(mapStateToProps)(
  ConnectedEditDevisFacturesComponent
)
export default translate("ProEditDevisFactures")(EditionDevisFacturesComponent)



// WEBPACK FOOTER //
// ./src/components/Pro/DevisFactures/EditionDevisFactures/EditionDevisFacturesComponent.js